"use strict";

angular.module("app").directive("tchMenu", ["$uibModal", "Utils", "AdminClientsService","ENV", function ($uibModal, Utils, AdminClientsService, ENV) {
		return {
			restrict: "E",
			templateUrl: "common/directives/menu/menu.html",
			controller: function ($scope, $http, $window, $location, $route, AdminService, SecurityService, SharedProperties, CONSTANTS, $timeout) {

				function getServeurDev() {
					switch ($location.host()) {
						case "integ.okina.fr" :
							$scope.bandeau = "INTEG";
							break;
						case "demo.okina.fr" :
							$scope.bandeau = "DEMO";
							break;
						case "region.bretagne.bzh" :
							$scope.bandeau = "PROD";
							break;
						case "mosaic.dev-2.okina.fr" :
							$scope.bandeau = "INTEG";
							break;
						case "mosaictest.ratpdev.com" :
							$scope.bandeau = "";
							break;
						case "localhost" :
							$scope.bandeau = "LOCAL";
							break;
						default :
							$scope.bandeau = "DEV";
							break;
					}
				}

				getServeurDev();


				$scope.data = {
					companies: SharedProperties.getAttribute(CONSTANTS.ATT_COMPANIES_ID),
					clientType: SharedProperties.getAttribute(CONSTANTS.ATT_CLIENT_TYPE),
					isTopologyActivatedForCurrentReferential: false,
					areDisruptionActivatedForCurrentReferential: false
				};

				AdminClientsService.refreshUserClients();
				AdminClientsService.watchUserClients( (clients) => {
					$scope.data.referentials = clients.sort(function (refA, refB) {
						if ($scope.getMenuName(refA).toLowerCase() > $scope.getMenuName(refB).toLowerCase()) {
							return 1;
						} else {
							return -1;
						}
					});
					let parentRef;
					if ($scope.isSimulation()) {
						const ref = window.sessionStorage.getItem("referential");
						parentRef = ref.replace(/^simulation_/,"");
					} else {
						parentRef = window.sessionStorage.getItem("referential");
					}
					if(!$scope.hasRight('accessToTechnicalOrganisation')){
						// user is not allowed to access technical organisation. Technical organisation is removed from available referentials
						$scope.data.referentials = $scope.data.referentials.filter(referential => referential.code.toLowerCase() !== "technique");
					}
					$scope.data.selectedReferential = clients.find(c => c.code === parentRef);
				});


				AdminClientsService.getAllClients(false).then((response) => {
					const clients = response.data;
					const client = clients.find(e => e.code === window.sessionStorage.referential);
					if (!$scope.isSimulation()) {
						$scope.idfm = client.idfm;
						window.sessionStorage.setItem("idfm", client.idfm);
					}
				}).catch(() => {});

				$scope.getMenuName = function (referential) {
					if (referential.nickname != null && referential.nickname !== "") {
						return referential.nickname;
					} else {
						return referential.name;
					}
				};

				$scope.logout = function () {
					SecurityService.logout();
				};

				$scope.referentialChanged = function () {
					window.sessionStorage.setItem("referential", $scope.data.selectedReferential.code);
					$window.location.reload();
				};

				$scope.isSimulation = function () {
					const ref = sessionStorage.getItem("referential");
					if (ref != null) {
						return ref.startsWith("simulation_");
					} else {
						return false;
					}
				}

				$scope.getEnvironnementName = function () {
					return SharedProperties.getAttribute(CONSTANTS.ATT_CLIENT_OBJECT) !== undefined ? SharedProperties.getAttribute(CONSTANTS.ATT_CLIENT_OBJECT).name : undefined;
				};

				$scope.getVersion = function () {
					return $window._env_.VERSION_OKINA;
				}

				$scope.checkSettings = function () {
					AdminService.getSchoolItiSettingsByToken()
						.then((response) => {
							const data = response.data;
							$scope.isFacturationV2 = !!(data && data.facturationVersion === "V2");
						}).catch(() => {});
					AdminService.getUserByToken()
						.then((response) => {
							const data = response.data;
							$scope.isOptionTravelerInformation = !!(data && data.client.optionTravelerInformation);
							$scope.isOptionIndiscipline = !!(data && data.client.optionIndiscipline);
						}).catch(() => {});
				};




				/**
				 * Cherche si l'utilisateur est en mode exploitation
				 */
				$scope.findIfExploitationMode = function () {
					var configurations = SharedProperties.getAttribute(CONSTANTS.ATT_CONFIGURATIONS);

					// Cas où pas encore connecté
					if (configurations === undefined) {
						return false;
					}

					var index = configurations.findIndex(function findFitiConfigMode(element) {
						return element["property"] === "FITI_CONFIG_MODE";
					});
					if (index >= 0) {
						return configurations[index].value === "EXPLOITATION";
					}
					return false;
				};

				/**
				 * Check wheter a given path is the current route or not
				 * We have to split location.path and route to compare only two first segments of URL.
				 * @param routeName
				 * @returns {boolean}
				 */
				$scope.isActive = function (routeName) {

					var isActive = false;
					var splittedPath = $location.path().split("/");
					var splittedRoute = routeName.split("/");
					if (splittedPath.length > 2) {
						isActive = splittedPath[1] + splittedPath[2] === splittedRoute[1] + splittedRoute[2];
					} else {
						isActive = splittedPath[1] === splittedRoute[1];
					}
					return isActive;
				};


				/**
				 * On vérifie qu'un menu de premier niveau est actif.
				 *
				 * @param routeName la route angular à vérifier.
				 * @returns {boolean}
				 */
				$scope.isFirstLevelActive = function (routeName) {
					return $location.path().indexOf(routeName) !== -1;
				};


				/**
				 * Check that a user is allowed to display a given menu item.
				 *
				 * @param menuItem logical menu item name => the 'name' element in route configuration
				 * @returns {boolean} Whether to display the menu item or not
				 */
				$scope.checkMenuItemPermissions = function (menuItem) {
					let accessGranted = false;
					const route = fetchMenuItemFromRoutesConfiguration(menuItem);

					/*
					 *  If it's a private route,
					 *  - verify user is connected
					 *  - check user's permissions
					 */
					if (route) {
						if (route.isPublic || SecurityService.checkAccess(menuItem)) {
							accessGranted = true;
						}
					}
					return accessGranted;
				};

				$scope.hasRight = (rightName) => SecurityService.hasRight(rightName);

				$scope.openVersionModal = function () {
					Utils.openModal($uibModal, "version.html", $scope);
				};

				$scope.openWarningSimulationModal = function () {
					Utils.openModal($uibModal, "warningSimulation.html", $scope);
				};

				$scope.initSimulationSpace = function () {
					localStorage.setItem("openSimulation", true);
					localStorage.setItem("simulationRef", "simulation_" + sessionStorage.getItem("referential"));
					return AdminClientsService.initSimulation($scope.data.selectedReferential);
				}

				$scope.resetSimulationData = function () {
					AdminClientsService.resetSimulation($scope.data.selectedReferential);
					Utils.openModal($uibModal, "waitForSimulationReset.html", $scope);

					$timeout(function() {
						// Action à effectuer après le délai de 10 secondes
						$window.location.reload();
					}, 8000);

				}


				async function initModuleAutorizations() {
					const client = await AdminClientsService.getCurrentClient();
					if(client != null){
						let moduleAccessibilityResp = await AdminClientsService.getClientModuleAccessibilitites(client.id);
						if (moduleAccessibilityResp.status === 200 && moduleAccessibilityResp.data) {
							$scope.data.isTopologyActivatedForCurrentReferential = moduleAccessibilityResp.data.is_topology_activated;
							$scope.data.areDisruptionActivatedForCurrentReferential =  moduleAccessibilityResp.data.are_disruptions_activated;
						}
					}
				}


				initModuleAutorizations();


				var fetchMenuItemFromRoutesConfiguration = function (menuItem) {
					for (var route in $route.routes) {
						var routeObject = $route.routes[route];
						if (routeObject && routeObject.name === menuItem) {
							return routeObject;
						}
					}
				};
			}
		};
	}]
)
;

